// The app's own blue-gradient car (a vector of Android's `car_icon`) and,
// for the empty garage, Android's `ic_car_big_ok`. They stand for the user's
// car wherever there's no photo — a deliberate exception to Material Symbols
// (design.md §8).
// Decorative: the car's name is always next to it, so `alt=""`.

type Size = "sm" | "md" | "hero";

// Rendered CSS widths; height follows the source's 62×39 viewBox. The source
// is a vector (traced from the Figma brand artboard), so it stays sharp at
// any size and density.
const WIDTH: Record<Size, number> = { sm: 33, md: 40, hero: 140 };

export function CarImage({
  size = "sm",
  className,
}: {
  size?: Size;
  className?: string;
}) {
  const width = WIDTH[size];
  return (
    <img
      src="/car-icon.svg"
      alt=""
      width={width}
      height={Math.round((width * 39) / 62)}
      className={`car-img car-img--${size}${className ? ` ${className}` : ""}`}
      decoding="async"
    />
  );
}

// The empty-garage illustration (car with a green check), 348×272.
export function CarEmptyImage() {
  return (
    <img
      src="/car-empty.webp"
      alt=""
      width={128}
      height={100}
      className="car-empty-img"
      decoding="async"
    />
  );
}

// The Cars tab's outlined car, inlined so it takes the nav's `color`
// (`currentColor`) like the Material Symbols on the other tabs.
export function CarTabIcon({ className }: { className?: string } = {}) {
  return (
    <svg
      className={`car-tab-icon${className ? ` ${className}` : ""}`}
      viewBox="0 0 28 18"
      width={26}
      height={17}
      aria-hidden
      focusable="false"
    >
      <path
        className="car-tab-icon__body"
        d="M25.9592,7.6729C25.553,7.1535 25.0292,6.7336 24.429,6.4462C24.1774,6.3002 23.9359,6.1382 23.7059,5.9614C23.5425,5.7771 23.1216,5.1032 22.7848,4.565C22.4481,4.0268 21.9727,3.2802 21.5716,2.7129C21.0764,2.005 19.3728,0.8511 13.7917,1.0159C12.4051,0.9868 8.0522,0.9723 6.4626,2.262C6.2941,2.4035 6.1459,2.5666 6.0218,2.7468C5.6207,3.3044 5.1849,3.9977 4.8085,4.6038C4.4322,5.2098 4.0508,5.8159 3.8874,5.9953C3.6561,6.1727 3.4129,6.3347 3.1595,6.4802C2.5615,6.7689 2.0396,7.1886 1.6342,7.7068C1.1935,8.3808 0.9904,9.4135 0.9904,10.9456V15.4256C0.9904,16.1593 1.5979,16.7541 2.3473,16.7541H5.0413C5.7907,16.7541 6.3982,16.1593 6.3982,15.4256V14.8341H21.2051V15.3868C21.2038,15.7396 21.3463,16.0782 21.6011,16.3276C21.8558,16.5771 22.2017,16.7166 22.562,16.7153H25.251C25.6117,16.7166 25.9581,16.5772 26.2137,16.3279C26.4692,16.0786 26.6129,15.74 26.6129,15.3868V10.9117C26.603,9.3795 26.3999,8.3468 25.9592,7.6729Z"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fillRule="evenodd"
      />
      <path
        className="car-tab-icon__light"
        d="M3,10.4988C3,10.4988 7.364,10.9764 8,10.303"
        fill="none"
        stroke="currentColor"
        strokeWidth={1}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="car-tab-icon__light"
        d="M25,10.4988C25,10.4988 20.636,10.9764 20,10.303"
        fill="none"
        stroke="currentColor"
        strokeWidth={1}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
